import {useState, useMemo} from 'react';
import {compose} from '../../lib/compose';
import {Row, Col, Form} from 'react-bootstrap';
import withAlerts from '../../lib/withAlerts';
import {usePolicyMutations} from './policyMutations';
import {usePortalContext} from '../../lib/context/portalContext';
import {useCustomerContext} from '../../lib/context/customerContext';
import {useForm, FormProvider} from "react-hook-form";
import {ErrorMessage} from '@hookform/error-message';
import PolicyForm from './policyForm';
import MinimumPolicyConfirmModal from './confirmMinimumPolicy';

const MinimumPolicy = ({minPolicy, alerts = {}, clicked = ''}) => {
  const {togglePortal} = usePortalContext();
  const [thresholdError, setThresholdError] = useState(null);
  const [popOpen, setPopOpen] = useState(false);
  const [accounts, setAccounts] = useState(null);
  const [existsError, setExistsError] = useState(null);
  const {success,error} = alerts;
  const {testMin, editMin} = usePolicyMutations();
  const {rca} = useCustomerContext();

  const methods = useForm({
    mode: 'all',
    defaultValues: useMemo(() => {
      return minPolicy;
    }, [minPolicy])
  });

  const {getValues, formState:{errors}} = methods;

  const testMinimumPolicy = async (e) => {    
    e.stopPropagation();
    const formData = getValues();
    
    //throw an error if the threshold isnt set
    if( formData.has_battery_warning && (formData.battery_warning_threshold === 0 || formData.battery_warning_threshold === undefined)) {
      setThresholdError('Battery Level Sufficient percentage is required.');
      return;
    }

    const minPolicyShape = {
      is_cellular_connected: formData?.is_cellular_connected,
      is_phone_protected: true, //formData?.is_phone_protected,
      battery_warning_threshold: formData?.battery_warning_threshold,
      has_battery_warning: formData?.has_battery_warning
    };
    
    //New Minimum Policy to test
    const testMinPolicy = await testMin({variables: {policy: minPolicyShape}});
    
    if(testMinPolicy?.errors) {
      error({msg: "There was an error validating the Minimum Policy. Please try again."});
    } else {
      setAccounts(testMinPolicy?.data?.TestMinimumPolicy?.result?.noncompliant_accounts);
      setPopOpen(true);
    }
  }

  const onSubmit = async (formData) => {    
    
    //throw an error if the threshold isnt set
    if( formData.has_battery_warning && (formData.battery_warning_threshold === 0 || formData.battery_warning_threshold === undefined)) {
      setThresholdError('Battery Level Sufficient percentage is required.');
      return;
    }

    const minPolicyShape = {
      is_cellular_connected: formData?.is_cellular_connected,
      is_phone_protected: true, //formData?.is_phone_protected,
      battery_warning_threshold: formData?.battery_warning_threshold,
      has_battery_warning: formData?.has_battery_warning
    };
    
    //Edit minimum policy
    const editMinPolicy = await editMin({variables: {policy: minPolicyShape}});
    
    if(editMinPolicy?.errors) {
      error({msg: "There was an error editing the Minimum Policy. Please try again."});
      
    } else {
      success({msg: `Minimum Policy updated.`});
      togglePortal();
    }
  }

  return (
    <FormProvider {...methods}>
      <Form>
        <PolicyForm
          minPolicy={minPolicy}
          existsError={existsError}
          setExistsError={setExistsError}
          thresholdError={thresholdError}
          setThresholdError={setThresholdError}
          showAllFormElements={false}
          clicked={clicked} //tells policy form the origin
          rca={rca}
        />
        <Row>
          <Col>
            <div className="d-grid gap-2">
              
              {rca && //root acct customer admin
                <MinimumPolicyConfirmModal
                  onChange={methods.handleSubmit(onSubmit)}
                  onClick={testMinimumPolicy}
                  popOpen={popOpen}
                  accounts={accounts}
                  setPopOpen={setPopOpen}
                />
              }
              
              <div className="mb-3">
                <ErrorMessage
                  errors={methods?.errors}
                  name="name"
                  render={({ message }) => <strong>{message}</strong>}
                />
                     
                {existsError && <strong className="mb-3 d-block">{existsError}<br/></strong>}
                {thresholdError && <strong className="mb-3 d-block">{thresholdError}<br/></strong>}
              </div>
            </div>
          </Col>
        </Row>
      </Form>
    </FormProvider>
    
  )
}

export default compose(
  withAlerts,
)(MinimumPolicy);
